import { Reveal } from "@/lib/motion";
import { Chapter } from "./Chapter";
import { SKILLS } from "@/data/content";

export const Skills = () => (
  <section id="skills" className="relative z-10 py-24 md:py-32 lg:py-40">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
      <Chapter num="06" title="Skills" kicker="Toolkit" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
        {SKILLS.map((col, i) => (
          <Reveal key={col.group} delay={i * 0.1}>
            <div>
              <span className="eyebrow mb-6 block">{col.group}</span>
              <ul>
                {col.items.map((item, j) => (
                  <li
                    key={item}
                    className="group flex items-baseline gap-3 py-3.5 border-b border-[#dfe1d5] text-[16.5px] text-[#16324f]"
                  >
                    <span className="font-mono-plex text-[12.5px] text-[#b5423a]">
                      {`0${j + 1}`}
                    </span>
                    <span className="group-hover:translate-x-1 transition-transform duration-400">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
